import React, { useState } from "react";
import { TableCell, TableRow, Tooltip, IconButton } from "@material-ui/core"
import CreateOutlinedIcon from "@material-ui/icons/CreateOutlined";
import VisibilityIcon from '@material-ui/icons/Visibility';
import DeleteOutlinedIcon from "@material-ui/icons/DeleteOutlined";
import { withRouter } from "react-router-dom";
import moment from 'moment';
import RevisionHistory from '../../../shared_elements/components/RevisionHistory';
import { permissionCheckFnforCamo } from '../../../utils';
const ConfigureListing = ({ item, toggleModalFn, toggleDelteModalFn, onView }) => {
    const [lessMore, setLessMore] = useState({});
    let timezone = moment().format()
    const timestamp = Math.floor(Date.now() / 1000);
    const Configure_url = `audit/camo/disclemerrevision/?object_id=${item.id}&action=0,1&timezone=${timezone}&timestamp=${timestamp}`

    const toggleLessMore = (lessMr) => {
        setLessMore({
            ...lessMore,
            [lessMr]: !lessMore[lessMr]
        });
    }

    const lessMoreFn = (name, lessMr) => {
        return <>
            {name && name?.length > 35 ? (
                <>
                    {lessMore[lessMr] ?
                        (<> {name} <span style={{ color: "#0e7fe1" }} onClick={(e) => { e.preventDefault(); toggleLessMore(lessMr); }}  > ..less </span> </>)
                        :
                        (<>{name.substring(0, 35)} <span style={{ color: "#0e7fe1" }} onClick={(e) => { e.preventDefault(); toggleLessMore(lessMr); }}  > ..more </span> </>)
                    }
                </>
            ) : name || '--'
            }
        </>
    }
    return (
        <>
            <TableRow>
                <TableCell style={{minWidth:'120px'}}>
                    <div style={{gap: "3px",display:"inline-flex" }}>
                        <Tooltip title="View" arrow placement='top'>
                            <VisibilityIcon  color='primary' style={{ fontSize: "1.35rem",cursor: 'pointer' }} onClick={onView} />
                        </Tooltip>
                        {permissionCheckFnforCamo({ primaryKey: "ad_status", keyIndex: "U" }) ? <Tooltip title="Edit" arrow placement='top'>
                            <CreateOutlinedIcon color='primary' style={{ fontSize: "1.35rem" ,cursor: 'pointer'}} onClick={toggleModalFn} />
                        </Tooltip> : null}
                        {permissionCheckFnforCamo({ primaryKey: "ad_status", keyIndex: "D" }) ? <Tooltip title="Delete" arrow placement='top' >
                            <DeleteOutlinedIcon  color='secondary' style={{ fontSize: "1.35rem",cursor: 'pointer' }} onClick={toggleDelteModalFn} />
                        </Tooltip> : null}
                        <RevisionHistory buttonType={true} url={Configure_url} />
                    </div>
                </TableCell>
                <TableCell>{item?.revision_number || '--'}</TableCell>
                <TableCell>{item?.engine_family?.name || '--'}</TableCell>
                <TableCell style={{minWidth:'140px'}}>{lessMoreFn(item?.engine_type?.map((item) => item?.name)?.filter(Boolean).join(', '), "engine_type")}</TableCell>
                <TableCell style={{minWidth:'120px'}}>{item?.disclemer_message ? item?.disclemer_message : '--'}</TableCell>
                <TableCell>{item?.status ? "Link" : '--'}</TableCell>

            </TableRow>
        </>
    )
}

export default withRouter(ConfigureListing)